import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import {
  decimalInvertedReportFormatter,
  percentageReportFormatter,
} from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function AgentBalance() {
  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [select, setSelect] = useState(0);
  const onSelectChange = useCallback(
    (event) => setSelect(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />

        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Agents Selection">
            <FormControl component="fieldset">
              <RadioGroup label value={select} onChange={onSelectChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="With Balance"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Grouping Balance Report"
        getUrl={() => "/Reports/Report_Agent_Balance"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Group: group,
          Book: book,
          Distributor: distributor,
          Select: select,
        })}
        getProcess={(data) =>
          data.map((item) => ({
            ...item,
          }))
        }
        getTotals={(data) => ({
          agent: "",
          agentType: "",
          percent: "Totals",
          currentBalance: data.reduce(
            (total, item) => total + item.currentBalance,
            0
          ),
          makeUp: data.reduce((total, item) => total + item.makeUp, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agentType">
          Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="commSports"
          dataFormat={percentageReportFormatter}
        >
          Percent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="currentBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          Balance
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="makeUp"
          dataFormat={decimalInvertedReportFormatter}
        >
          MakeUp
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default AgentBalance;
